import styled from 'styled-components';
import { Button } from '@/ui';

export const PageWrapper = styled.div<{
  $height: number;
}>`
  background-color: var(--color-background);
  color: var(--color-foreground);
  min-height: ${({ $height }) => $height}px;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  padding: var(--spacing-md) var(--spacing-lg);
`;

export const Logo = styled.div`
  height: 40px;
  width: 150px;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(/images/logo-dark.svg);
`;

export const Content = styled.main`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-xl);
`;

export const Container = styled.div`
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-lg);
  form {
    width: 100%;
  }
`;

export const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: var(--radius-lg);
  overflow: hidden;
`;

export const ControlsOverlay = styled.div`
  position: absolute;
  bottom: var(--spacing-sm);
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: var(--spacing-md);
`;

export const InputGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
  padding-bottom: var(--spacing-md);
  max-width: 320px;
  margin: 0 auto;
`;

export const JoinButton = styled(Button)`
  display: block;
  max-width: 320px;
  width: 100%;
  margin: 0 auto;
`;
